import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import ScreenTransition from './ScreenTransition';

function Contact() {
  const navigate = useNavigate();
  return (
    <ScreenTransition direction="right">
      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        <div className="bg-zinc-900/60 px-4 py-6 sm:p-8 rounded-2xl max-w-4xl w-full overflow-y-auto max-h-[90vh]">
          <div className="mb-6 flex flex-col items-center">
            <Button onClick={() => navigate('/')} className="w-32 mb-6">
              Back
            </Button>
            <h1 className="text-2xl sm:text-3xl font-bold text-center mb-6 text-yellow-300">
              Contact Us
            </h1>
          </div>

          <div className="space-y-6 text-gray-200 text-sm sm:text-base leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-yellow-300 mb-3">Get in Touch</h2>
              <p className="mb-4">
                We'd love to hear from you! Whether you have questions, feedback, suggestions, or need support, feel free to reach out to us. Your input helps us improve Wall Go and make it better for all players.
              </p>
            </section>

            <section>
              <p className="text-center mb-6">
                <a
                  href="mailto:tete.dans.les.clouds@gmail.com"
                  className="text-yellow-300 hover:text-yellow-400 underline transition-colors text-lg font-semibold"
                >
                  tete.dans.les.clouds@gmail.com
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-yellow-300 mb-3">What to Contact Us About</h2>
              <ul className="list-disc list-inside mb-3 space-y-2 ml-4">
                <li><strong>Bug Reports:</strong> If you encounter any technical issues, glitches, or unexpected behavior while playing Wall Go, please let us know. Include details about what happened and what you were doing when the issue occurred.</li>
                <li><strong>Feature Suggestions:</strong> Have an idea for a new feature or improvement? We're always looking for ways to enhance the game experience based on player feedback.</li>
                <li><strong>Gameplay Questions:</strong> If you have questions about how to play, game rules, or strategies, we're happy to help clarify.</li>
                <li><strong>Feedback:</strong> Share your thoughts about the game, what you enjoy, and what could be improved. Your perspective is valuable to us.</li>
                <li><strong>Technical Support:</strong> If you're experiencing problems accessing or running the game, we can help troubleshoot.</li>
                <li><strong>Partnership Inquiries:</strong> For business or partnership opportunities, please reach out with details about your proposal.</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </ScreenTransition>
  );
}

export default Contact;
